(() => {
  if (window.jrWowReady) return;
  window.jrWowReady = true;
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const pending = new WeakSet();
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      if (!motion.matches) entry.target.classList.add('jr-wow-enter');
      observer.unobserve(entry.target);
    });
  }, {threshold:0.08}) : null;
  function reveal(root) {
    root.querySelectorAll('.jr-wearlook-head,.jr-wearlook-item,.jr-monthly__heading,.jr-monthly__visual,.jr-monthly__copy,.jr-stock-picks h2,.m-collection-page-header h1,.m-product-card,.jr-clothing-card,.jr-shoe-card,.jr-jewelry-card,.jr-why-head,.m-main-product--info h1').forEach(el => {
      if (pending.has(el) || !observer) return;
      pending.add(el);
      observer.observe(el);
      el.addEventListener('animationend', () => el.classList.remove('jr-wow-enter'), {once:true});
    });
  }
  reveal(document);
  document.addEventListener('shopify:section:load', event => reveal(event.target));
  function decorate(root) {
    root.querySelectorAll('.jr-shop-hero__media,.jr-wearlook-photo').forEach(el => {
      if (el.querySelector('.jr-glitter-field')) return;
      const field = document.createElement('div');
      field.className = 'jr-glitter-field'; field.setAttribute('aria-hidden','true');
      for (let i=0;i<12;i++) {
        const dot=document.createElement('span'); dot.className='jr-glitter-dot'; dot.textContent=i%3?'✦':'✧';
        dot.style.left=(3+(i*37)%94)+'%'; dot.style.top=(3+(i*23)%90)+'%';
        dot.style.setProperty('--jr-size',(10+i%5*4)+'px');dot.style.setProperty('--jr-delay',(-i*.37)+'s');field.append(dot);
      }
      el.append(field);
    });
  }
  decorate(document);
  document.addEventListener('shopify:section:load',event=>decorate(event.target));
  let frame=0;
  function wings() {
    frame=0;
    document.querySelectorAll('.jr-shop-hero').forEach(hero=>{
      const r=hero.getBoundingClientRect();
      if(r.bottom<0 || r.top>innerHeight) return;
      const progress=Math.min(1,Math.max(0,(innerHeight-r.top)/(innerHeight+r.height)));
      hero.style.setProperty('--jr-wing-scale',motion.matches?'1':String(1+progress*.8));
    });
  }
  addEventListener('scroll',()=>{if(!frame)frame=requestAnimationFrame(wings)},{passive:true});
  addEventListener('resize',wings,{passive:true}); motion.addEventListener('change',wings); wings();
  let last = 0;
  addEventListener('scroll', () => {
    const now = Date.now();
    if (motion.matches || document.hidden || now - last < 420) return;
    if (document.querySelector('dialog[open],.m-cart-drawer.m-cart-drawer--open')) return;
    last = now;
    const mobile = innerWidth < 768;
    if (document.querySelectorAll('.jr-silver-scroll-spark').length > 12) return;
    for (let i = 0; i < (mobile ? 2 : 4); i++) {
      const spark = document.createElement('span');
      spark.className = 'jr-silver-scroll-spark';
      spark.setAttribute('aria-hidden', 'true');
      spark.textContent = i % 2 ? '✧' : '✦';
      const edge = mobile ? 42 : 100;
      spark.style.left = (i % 2 ? innerWidth - 18 - Math.random()*edge : 4 + Math.random()*edge) + 'px';
      spark.style.top = (90 + Math.random()*Math.max(1,innerHeight-190)) + 'px';
      spark.style.fontSize = (mobile ? 12 : 15) + Math.random()*12 + 'px';
      document.body.append(spark);
      spark.addEventListener('animationend', () => spark.remove(), {once:true});
      setTimeout(() => spark.remove(), 2000);
    }
  }, {passive:true});
})();


(()=>{
const selector='.m-header__desktop .m-menu__item--dropdown';
function position(root){
 if(innerWidth<1024)return;
 const menu=root.querySelector(':scope > .m-mega-menu');if(!menu)return;
 const anchor=root.getBoundingClientRect();
 root.classList.toggle('jr-dropdown-align-end',anchor.left+menu.offsetWidth>document.documentElement.clientWidth-16);
 const header=root.closest('.m-header__desktop').getBoundingClientRect();
 menu.querySelectorAll('.m-sub-menu__item--level-1').forEach(item=>{
  const flyout=item.querySelector(':scope > .m-mega-menu__column');if(!flyout)return;
  const rect=item.getBoundingClientRect();
  item.classList.toggle('jr-flyout-left',rect.right+16+flyout.offsetWidth>document.documentElement.clientWidth-16);
  const start=Math.max(16,header.bottom);
  const space=Math.max(96,innerHeight-start-20);
  flyout.style.setProperty('--jr-flyout-height',space+'px');
  const height=Math.min(flyout.scrollHeight,space);
  const top=Math.max(start,Math.min(rect.top-16,innerHeight-height-20));
  flyout.style.setProperty('--jr-flyout-top',(top-rect.top)+'px');
 });
}
const update=event=>{const root=event.target.closest?.(selector);if(root)position(root);};
document.addEventListener('pointerover',update);document.addEventListener('focusin',update);
addEventListener('resize',()=>document.querySelectorAll(selector).forEach(position),{passive:true});
document.querySelectorAll(selector).forEach(position);
})();

(()=>{
function decorateChristmas(){
 document.querySelectorAll('.m-header__desktop .m-header__top').forEach(header=>{
  if(header.querySelector('.jr-christmas-baubles'))return;
  const balls=document.createElement('div');balls.className='jr-christmas-baubles';balls.setAttribute('aria-hidden','true');
  for(let i=0;i<10;i++){const ball=document.createElement('span');ball.className='jr-christmas-bauble';balls.append(ball);}header.append(balls);
 });
 if(document.querySelector('.jr-christmas-snow'))return;
 const snow=document.createElement('div');snow.className='jr-christmas-snow';snow.setAttribute('aria-hidden','true');
 for(let i=0;i<18;i++){
  const flake=document.createElement('span');flake.className='jr-christmas-snowflake';flake.textContent=i%3?'❄':'✧';
  flake.style.setProperty('--jr-snow-x',((i*37+3)%96)+'%');flake.style.setProperty('--jr-snow-size',(9+i%4*2)+'px');
  flake.style.setProperty('--jr-snow-time',(14+i%6*2)+'s');flake.style.setProperty('--jr-snow-delay',(-i*1.9)+'s');snow.append(flake);
 }document.body.append(snow);
}
decorateChristmas();document.addEventListener('shopify:section:load',decorateChristmas);
document.addEventListener('visibilitychange',()=>document.querySelector('.jr-christmas-snow')?.classList.toggle('jr-christmas-snow--paused',document.hidden));
})();

(()=>{
const ready=new WeakSet(),motion=matchMedia('(prefers-reduced-motion: reduce)');
function init(){document.querySelectorAll('[data-jr-crossfade]').forEach(media=>{
 if(ready.has(media))return;const slides=[...media.querySelectorAll('.jr-campaign__image')];if(slides.length<2)return;ready.add(media);media.classList.add('jr-slideshow');let index=0,timer;
 function load(i){if(motion.matches||document.hidden)return;const image=slides[i];if(!image.dataset.jrSrc)return;image.loading='eager';if(image.dataset.jrSrcset){image.srcset=image.dataset.jrSrcset;delete image.dataset.jrSrcset;}image.src=image.dataset.jrSrc;delete image.dataset.jrSrc;}
 function preload(){setTimeout(()=>load((index+1)%slides.length),1200);}
 const show=next=>{slides.forEach((slide,i)=>slide.classList.toggle('is-active',i===next));index=next;preload();};slides[0].classList.add('is-active');
 const start=()=>{clearInterval(timer);if(motion.matches||document.hidden)return;timer=setInterval(()=>{const next=(index+1)%slides.length;load(next);if(slides[next].complete&&slides[next].naturalWidth>0)show(next);},Number(media.dataset.interval)||5000);};
 motion.addEventListener('change',()=>{if(motion.matches)show(0);else preload();start();});document.addEventListener('visibilitychange',()=>{preload();start();});
 if(slides[0].complete)preload();else slides[0].addEventListener('load',preload,{once:true});start();
});}init();document.addEventListener('shopify:section:load',init);
})();
(()=>{
const template=document.getElementById('JRFestiveWelcome');
if(!template||matchMedia('(prefers-reduced-motion: reduce)').matches)return;
try{if(sessionStorage.getItem('jr-festive-welcome-v4'))return;sessionStorage.setItem('jr-festive-welcome-v4','1');}catch{}
const welcome=template.content.firstElementChild.cloneNode(true);
function show(){document.body.append(welcome);welcome.addEventListener('animationend',event=>{if(event.animationName==='jrWelcomeRide')welcome.remove();});setTimeout(()=>welcome.remove(),16000);}
const image=welcome.querySelector('img');if(image&&image.decode){image.decode().then(show).catch(show);}else{show();}
})();

(()=>{
function mobileBaubles(){document.querySelectorAll('.m-header__mobile').forEach(header=>{
 if(header.querySelector('.jr-mobile-baubles'))return;
 const decor=document.createElement('div');decor.className='jr-christmas-baubles jr-mobile-baubles';decor.setAttribute('aria-hidden','true');
 for(let i=0;i<7;i++){const ball=document.createElement('span');ball.className='jr-christmas-bauble';if(i===0||i===4){const bow=document.createElement('span');bow.className='jr-bauble-bow';ball.append(bow);}decor.append(ball);}header.append(decor);
});}mobileBaubles();document.addEventListener('shopify:section:load',mobileBaubles);
})();

(()=>{
const motion=matchMedia('(prefers-reduced-motion: reduce)');let frame=0;
function update(){frame=0;const amount=motion.matches?0:Math.min(1,Math.max(0,scrollY/Math.min(360,innerHeight*.48)));document.querySelectorAll('.jr-satin-bow').forEach(bow=>bow.style.setProperty('--jr-bow-open',String(amount)));}
function schedule(){if(!frame)frame=requestAnimationFrame(update);}
addEventListener('scroll',schedule,{passive:true});addEventListener('resize',schedule,{passive:true});motion.addEventListener('change',schedule);document.addEventListener('shopify:section:load',schedule);update();
})();

(()=>{
const root=document.getElementById('jrInfluencerSlider');if(!root||!('IntersectionObserver' in window))return;
const seen=new WeakSet(),motion=matchMedia('(prefers-reduced-motion: reduce)');
const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{
 const video=entry.target;if(entry.isIntersecting&&!document.hidden&&!motion.matches){
 let loaded=false;video.querySelectorAll('source[data-jr-video-src]').forEach(source=>{source.src=source.dataset.jrVideoSrc;delete source.dataset.jrVideoSrc;loaded=true;});
 if(loaded)video.load();video.play()?.catch(()=>{});
 }else video.pause();
}),{rootMargin:'100px 0px',threshold:.01});
function watch(){root.querySelectorAll('video').forEach(video=>{if(seen.has(video))return;seen.add(video);observer.observe(video);});}
watch();new MutationObserver(watch).observe(root,{childList:true,subtree:true});
document.addEventListener('visibilitychange',()=>{if(document.hidden)root.querySelectorAll('video').forEach(video=>video.pause());});
})();
